import { type JanusCtx, type Row, record, upper, definitionNotHeld } from './context.js';
import { inventoryDefinition, inventoryCatalog } from '../inventory/definition.js';
import { inventoryFootprint, normalizeTransform, type Zone } from '../inventory/floor-move.js';
import { inventoryAuthoredSizeId } from '../inventory/solid-obstacle.js';
import { selectedPropMeshSpaceOrTier } from '../inventory/prop-mesh-space.js';
import { readInventoryField } from '../compile/inventory-raw-readers.js';
import { posCoord } from '../../shared/array-types.js';
import { SIZE_WIDTHS_FT } from '../inventory/lift-occupancy.js';

/** Shared stateless reader: use the drawn mesh/scale/yaw, otherwise the ordinary size-tier footprint. */
export function surfaceInventoryFootprint(ctx: Pick<JanusCtx, 'read' | 'encounter'>, row: Row): Zone {
  const def = inventoryDefinition(row, ctx.encounter.catalog, ctx.read.definition);
  if (!def) definitionNotHeld('swarmfootprint31:footprint-definition-not-held', readInventoryField(row, 'inventory_item_id'));
  const mesh = selectedPropMeshSpaceOrTier(row, def, inventoryCatalog(row, ctx.encounter.catalog, def));
  const field = (key: string): unknown => ctx.read.inventoryField?.(row, key) ?? readInventoryField(row, key);
  const inventorySize = upper(field('inventory_size')) || null;
  const templateSizeId = upper(def ? ctx.read.value(def, 'size') : '') || null;
  const sizeId = inventoryAuthoredSizeId(row, def);
  return inventoryFootprint({ itemType: String(record(def?.items)?.item_type ?? ''),
    x: posCoord(row, 'x_pos') ?? 0, y: posCoord(row, 'y_pos') ?? 0, z: posCoord(row, 'z_pos') ?? 0,
    transform: normalizeTransform(field('transform_3d')), sizeId, inventorySize, templateSizeId,
    worldMeshBoundsM: mesh?.boundsM ?? null, worldMeshAuthoredSizeTypeId: mesh?.authoredSizeTypeId,
  }, id => SIZE_WIDTHS_FT[id] ?? null);
}
